<template>
  <div class="dashboard-view">
    <title-component :size="1">
      <translate>Dashboard</translate>
      <div class="is-pulled-right">
        <button class="button is-info is-uppercase" @click="applyForService()">
          <translate>Apply for new service</translate>
        </button>
      </div>
    </title-component>
     <message-component
      v-if="customer.shouldShowEmailGlnWarning"
      level="danger">
        <div class="is-flex-direction-row">
          <div class="is-flex-direction-column">
            <translate>
              Please, update your invoice information as you are missing invoice e-mail address or GLN.
            </translate>
          </div>
          <div class="is-flex-direction-column">
            <submit-btn-component class="is-success is-outlined mt-10" @submit="redirectToEdit">
              <translate>Edit information</translate>
            </submit-btn-component>
          </div>
        </div>
    </message-component>
    <message-component
      v-if="customer.shouldShowOldInformationAlert"
      level="warning">
        <div class="is-flex-direction-row">
          <div class="is-flex-direction-column">
            <translate>
              Please, remember to keep your contact information up to date as it ensures that we can get into contact with you for reminders about reporting and renewal cases.
            </translate>
          </div>
          <div class="is-flex-direction-column">
            <submit-btn-component class="is-success is-outlined mt-10" @submit="redirectToEdit">
              <translate>Edit information</translate>
            </submit-btn-component>
          </div>
        </div>
    </message-component>
    <invoice-information-view
      v-if="customer.needsInvoiceInformationUpdate"
      :customer="customer"></invoice-information-view>
    <issues-view :customer="customer"></issues-view>
    <table-component-buefy
      v-if="mixin.loaded && cases.length !== 0"
      :content="cases"
      :headings="headings"
      :item_keys="item_keys"
      :display_spec="caseSpecs"
      :total_items="mixin.total_items"
      :pagination_callback="mixin.loadItems"
      :hidden_columns="['modified', 'created']"
      class="veridens-dashboard">
      <translate>Your ongoing cases</translate>
    </table-component-buefy>
    <!-- Certificates section shown when no active cases -->
    <div v-if="mixin.loaded && cases.length === 0">
      <title-component :size="2">
        <translate>Your certificates</translate>
      </title-component>
      <b-table :data="certificates" v-if="certificates.length > 0">
        <template slot-scope="props">
          <b-table-column :label="'Certificate No.' | translate">
            <router-link :to="props.row.certificateLink" class="has-text-weight-semibold" style="color: rgb(0, 93, 161)">
              {{ props.row.certificateNumber }}
            </router-link>
          </b-table-column>
          <b-table-column :label="'Service' | translate">{{ props.row.service.shortName }}</b-table-column>
          <b-table-column :label="'Issued date' | translate">{{ props.row.issueDate }}</b-table-column>
          <b-table-column :label="'Expiry date' | translate">{{ props.row.expiryDate }}</b-table-column>
          <b-table-column label="">
            <button
              v-if="props.row.state.value === CertificateState.PUBLISH"
              class="button is-primary is-small"
              @click="openOrderCardModal(props.row)">
              <translate>Order card</translate>
            </button>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <!-- Order card confirmation modal -->
    <card-modal-component
      :show="show_id_card_modal"
      @deactivate="toggleIdCardModal()"
      transition="fade"
      ref="id_card_modal"
      :options="{hasOkBtn: { text: 'Order card' }, hasCancelBtn: { enabled: true }}"
      @handleOk="createIdCardOrder($event)"
      @handleCancel="toggleIdCardModal()"
      :title="'Order card' | translate">
      <div slot="card-content" class="field">
        <div class="control">
          <p v-translate>Please confirm that you want to order a card and also accept that you will be invoiced for this order which is currently priced at 495 SEK excluding VAT.</p>
        </div>
      </div>
      <span slot="ok-text" v-translate>Order card</span>
    </card-modal-component>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import IssuesView from '../issues/IssuesView.vue'
  import { caseSpecs } from '@/display_context/display_context'
  import { loadItemsMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import { CaseState } from '@/classes/case/Case'
  import { CertificateState } from '@/classes/certificate/Certificate'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'
  import InvoiceInformationView
    from '@/views/customer/issues/InvoiceInformationView.vue'

  export default {
    name: 'dashbaord-view',
    mixins: [loadItemsMixin, setContainedHeightMixin],
    data () {
      return {
        headings: ['Case number', 'Certification', 'Qualification', 'Case type', 'Created', 'State', 'Responsible', 'Progress', 'Updated'],
        item_keys: ['caseLink', 'service.shortName', 'qualification.value', 'caseType.display', 'created', 'state', 'responsible.profileTypeDisplay', 'progress', 'modified'],
        caseSpecs: caseSpecs,
        mixin: { actionMethod: this.getCases, actionParams: { 'state': CaseState.ongoingStates() } },
        CertificateState: CertificateState,
        show_id_card_modal: false,
        selectedCertificate: null
      }
    },
    components: {
      InvoiceInformationView,
      IssuesView,
      TitleComponent,
      TableComponentBuefy,
      MessageComponent,
      SubmitBtnComponent,
      CardModalComponent
    },
    computed: {
      ...mapState({
        cases: state => state.caseModule.cases,
        customer: state => state.profileModule.customerProfile,
        certificates: state => state.certificateModule.certificates
      })
    },
    methods: {
      ...mapActions([
        'getCases',
        'getCertificates',
        'getCustomerProfile',
        'updatePreviousLogin',
        'orderIdCard',
        'successMessage'
      ]),
      applyForService () {
        this.$router.push({ name: 'ApplyForServiceView' })
      },
      redirectToEdit () {
        this.$router.push({ name: 'CustomerEditView' })
      },
      openOrderCardModal (certificate) {
        this.selectedCertificate = certificate
        this.show_id_card_modal = true
      },
      toggleIdCardModal () {
        this.show_id_card_modal = !this.show_id_card_modal
      },
      createIdCardOrder (btn) {
        this.orderIdCard(this.selectedCertificate.id).then(() => {
          this.show_id_card_modal = false
          this.$refs.id_card_modal.closeModal().then(() => {
            this.successMessage(this.$ngettext('Card order created'))
            this.getCertificates({})
          })
        }).catch((err) => {
          this.handleError(err)
          btn.enable()
        })
      }
    },
    watch: {
      'mixin.loaded' (loaded) {
        if (loaded && this.cases.length === 0) {
          this.getCertificates({})
        }
      }
    },
    created () {
      this.getCustomerProfile().catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>
<style lang="sass" scoped>
  .veridens-dashboard
    @media screen and (min-width: 765px) and (max-width: 895px)
      font-size: 1.3vw
  .button
    height: auto
    width: auto
    padding: 0.7rem 1rem
</style>
